import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';

import ManifestShipment from 'components/add_order/manifest/ManifestDetail/ManifestShipment/ManifestShipment';
import ManifestDetailSummary from 'components/add_order/manifest/ManifestDetail/ManifestDetailSummary';

const ManifestDetail = () => {
  const { manifestId } = useParams();

  const handleManifestUpdate = useCallback(() => {
    window.dispatchEvent(new CustomEvent('manifest-updated'));
  }, []);

  return (
    <Row className="mt-1">
      <Col md={9} className="mb-3 mb-md-0">
        <ManifestShipment
          manifestId={manifestId}
          onManifestUpdate={handleManifestUpdate}
        />
      </Col>

      <Col md={3}>
        <ManifestDetailSummary
          manifestId={manifestId}
          showActionBtn={true}
          listenToUpdates={true}
        />
      </Col>
    </Row>
  );
};

export default ManifestDetail;
